export const DATA_LOAD_TIME_METRIC_NAME = 'com.tenera.data_load_completed';